import { useContainer } from '../../useContainer';
import { ClientApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { PostTermsDto } from '../../../commonTypes/client.types';

const useHttpPostPaymentTerms = () => {
    const { t } = useTranslation('newNotifications');
    const clientApi: ClientApi = useContainer(ClientApi);
    const toastHandler = useContainer(ToastStateHandler);

    const execPost = (terms: PostTermsDto[]) => {
        const { exec, abort } = clientApi.postTerms({
            body: terms,
            onSuccess: () => {
                toastHandler.push('success', t('invoice.termsCreateTitle'), t('invoice.termsCreateSuccess'));
            },
            onError: _ => toastHandler.push('error', t('invoice.termsCreateTitle'), t('invoice.termsCreateError')),
        });
        exec();
        return abort;
    };

    return { execPost };
};

export default useHttpPostPaymentTerms;
